import React from 'react'
import RoleLabel from './RoleLabel'

export default function ClientUserCommonDetails({ pbi }) {
    return (
        <div>
            <div className="flex-sec flex-sec2">
                <p>{pbi?.post_user_type || pbi?.mine?.user_type}</p>
                <p>{pbi?.user_type || pbi?.user?.user_type}</p>
            </div>
            <div className="flex-sec flex-sec3">
                <div>
                    <h6>
                        {pbi?.post_first_name || pbi?.mine?.first_name} {pbi?.post_last_name || pbi?.mine?.last_name}
                    </h6>
                    <p>Member ID : {pbi?.post_user_id || pbi?.mine?.id}</p>
                </div>
                <div>
                    <h6>
                        {pbi?.first_name || pbi?.user?.first_name} {pbi?.last_name || pbi?.user?.last_name}
                    </h6>
                    <p>Member ID : {pbi?.user_id || pbi?.user?.id}</p>
                </div>
            </div>
        </div>
    )
}
